import React, { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { XCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function InstallazioneKoButton({ cid, flusso, onSaved }) {
  const [saving, setSaving] = useState(false);
  const ko = flusso === "ko";

  const toggle = async () => {
    if (!ko && !window.confirm("Segnare l'installazione come KO? Il semaforo del cliente diventerà rosso.")) return;
    setSaving(true);
    try {
      await api.post(`/clienti/${cid}/installazione/ko`);
      toast.success(ko ? "Stato KO rimosso" : "Installazione segnata KO");
      onSaved?.();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="card-shell p-4 flex flex-wrap items-center gap-3" data-testid="installazione-ko-block">
      <button onClick={toggle} disabled={saving}
        className="text-sm disabled:opacity-60 inline-flex items-center gap-1.5 px-4 py-2 rounded-lg font-semibold transition"
        style={ko
          ? { background: "#991B1B", color: "#fff" }
          : { background: "#FEE2E2", color: "#991B1B", border: "1px solid #FCA5A5" }}
        data-testid="installazione-ko-btn">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <XCircle className="w-4 h-4" />}
        {ko ? "Installazione KO ✓ (clicca per annullare)" : "KO"}
      </button>
      <span className="text-xs flex-1 min-w-[200px]" style={{ color: "var(--text-muted)" }}>
        Segna l'installazione come KO: nella lista clienti il semaforo diventa rosso.
      </span>
    </div>
  );
}
